export const BANK_ACCOUNT_NUMBER_REGEX = /^[0-9]+$/;

export type BankAccountRule = {
  min: number;
  max: number;
};

export const BANK_ACCOUNT_NUMBER_RULES: Record<string, BankAccountRule> = {
  capitec: { min: 10, max: 10 },
  standardbank: { min: 9, max: 11 },
  absa: { min: 11, max: 11 },
  fnb: { min: 9, max: 11 },
  bidvestbank: { min: 9, max: 11 },
  'african bank': { min: 10, max: 10 },
  nedbank: { min: 10, max: 10 },
  'discovery bank': { min: 10, max: 10 },
  investec: { min: 10, max: 10 },
  'tyme bank': { min: 9, max: 11 },
  'bank zero': { min: 9, max: 11 },
  others: { min: 8, max: 14 }
};

const BANK_NAME_TO_KEY: Record<string, string> = {
  'Capitec Bank': 'capitec',
  'Standard Bank': 'standardbank',
  'ABSA Bank': 'absa',
  'First National Bank (FNB)': 'fnb',
  'Bidvest Bank': 'bidvestbank',
  'African Bank': 'african bank',
  'Nedbank': 'nedbank',
  'Discovery Bank': 'discovery bank',
  Investec: 'investec',
  TymeBank: 'tyme bank',
  'Bank Zero': 'bank zero',
  Other: 'others'
};

export const normalizeBankAccountInput = (value?: string): string => (value ?? '').trim();

export const resolveBankRuleKey = (bankName?: string): string | undefined => {
  const normalizedBankName = normalizeBankAccountInput(bankName);
  if (!normalizedBankName) return undefined;
  return BANK_NAME_TO_KEY[normalizedBankName] ?? undefined;
};

export const getBankAccountRuleForBank = (bankName?: string): BankAccountRule | undefined => {
  const key = resolveBankRuleKey(bankName);
  if (!key) return undefined;
  return BANK_ACCOUNT_NUMBER_RULES[key];
};

export const validateBankAccountNumber = (accountNumber?: string, bankName?: string): true | string => {
  const normalizedAccountNumber = normalizeBankAccountInput(accountNumber);
  const normalizedBankName = normalizeBankAccountInput(bankName);

  if (!normalizedAccountNumber) {
    return 'Account number is required.';
  }

  if (!normalizedBankName) {
    return 'Please select a bank before entering the account number.';
  }

  if (!BANK_ACCOUNT_NUMBER_REGEX.test(normalizedAccountNumber)) {
    return 'Invalid account number for the selected bank.';
  }

  const rule = getBankAccountRuleForBank(normalizedBankName) ?? BANK_ACCOUNT_NUMBER_RULES.others;
  if (normalizedAccountNumber.length < rule.min || normalizedAccountNumber.length > rule.max) {
    return 'Invalid account number for the selected bank.';
  }

  return true;
};
